// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","displayGrid":"_1xK0H","inner":"_1nOIp"};